import { AssetTypeBase } from './base/asset-type-base';

export class AssetType extends AssetTypeBase { }